import React from "react";
import Layout from "./../layout";
import { URLS } from "../../_config";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import ToggleSwitch2 from "../../components/ToggleSwitch2";

import { Tab, Tabs, Nav, Card, Form, Button, Row, Col } from "react-bootstrap";
const handleToggle2 = (state: boolean) => {
  console.log("Toggle state:", state);
};
const FundingOverview: React.FC = () => {
  return (
    <Layout>
      <div data-aos="fade-up" data-aos-duration="1000">
        <Breadcrumbs
          title="Loan Tracking"
          breadcrumbs={{
            Home: URLS.PROFILE,
            "Loan Tracking": URLS.FUNDINGOVERVIEW.LIST,
          }}
        />

        <div className="row">
          <div className="col-sm-9">
            <div className="row my-escalations-block">
              <div className="col-lg-3">
                <div className="card mini-stats-wid">
                  <div className="card-body card-accent d-flex align-items-center">
                    <div className="d-flex align-items-center gap-30">
                      <div className="card-left-icons">
                        <img src="assets/images/icons/total-escalations.svg" />
                      </div>
                      <div className="mr-3">
                        <p className="text-muted mb-2">Total Loan</p>
                        <h5 className="mb-0">120</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="card blog-stats-wid">
                  <div className="card-body card-black d-flex align-items-center">
                    <div className="d-flex align-items-center gap-30">
                      <div className="card-left-icons">
                        <img src="assets/images/icons/not-started.svg" />
                      </div>
                      <div className="mr-3">
                        <p className="text-muted mb-2">Inprogress</p>
                        <h5 className="mb-0">86</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card blog-stats-wid">
                  <div className="card-body card-purple d-flex align-items-center">
                    <div className="d-flex align-items-center gap-30">
                      <div className="card-left-icons">
                        <img src="assets/images/icons/started-icon.svg" />
                      </div>
                      <div className="mr-3">
                        <p className="text-muted mb-2">New Loan</p>
                        <h5 className="mb-0">1,534</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card blog-stats-wid">
                  <div className="card-body card-green d-flex align-items-center">
                    <div className="d-flex align-items-center gap-30">
                      <div className="card-left-icons">
                        <img src="assets/images/icons/complete-icon.svg" />
                      </div>
                      <div className="mr-3">
                        <p className="text-muted mb-2">Loan Completed</p>
                        <h5 className="mb-0">4,235</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="section-heading">
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <h2>Loan Overview</h2>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-light-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="bx bx-dots-vertical-rounded"></i>
                      </button>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="#">
                          10 Days
                        </a>
                        <a className="dropdown-item" href="#">
                          20 Days
                        </a>
                        <a className="dropdown-item" href="#">
                          30 Days
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="column_chart_datalabel"
                  className="apex-charts"
                  dir="ltr"
                >
                  <img src="assets/images/chart_01.jpg" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
                                








                                
                                <div className="card">
                                    <div className="card-body">
                                        <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-toggle="tab" href="#home12" role="tab">
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">To do list</span> 
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" data-toggle="tab" href="#profile12" role="tab">
                                                    <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                    <span className="d-none d-sm-block">To do overview</span> 
                                                </a>
                                            </li>
                                        </ul>
                                        
                                       
                                        <div className="tab-content py-3 text-muted px-0">
                                            <div className="tab-pane active" id="home12" role="tabpanel">
                                                <div className="section-heading mb-0 d-flex justify-content-between align-items-center mb-1">
                                                    <h2 className="mb-1">To do list</h2>
                                                    <p className="text-danger mb-0">You have 25 due task</p>
                                                </div>
                                                <form className="app-search">
                                                    <div className="position-relative">
                                                        <input type="text" className="form-control" placeholder="Search..."/>
                                                        <span className="bx bx-search-alt"></span>
                                                    </div>
                                                </form>
                                               
                                                <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" data-toggle="tab" href="#home1" role="tab">
                                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                            <span className="d-none d-sm-block">Your to do</span> 
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" data-toggle="tab" href="#profile1" role="tab">
                                                            <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                            <span className="d-none d-sm-block">Completed</span> 
                                                        </a>
                                                    </li>
                                                </ul>
                                                
                                               
                                                <div className="tab-content py-3 text-muted px-0">
                                                    <div className="tab-pane active" id="home1" role="tabpanel">
                                                        <div className="to-do-list-block-panel">
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane" id="profile1" role="tabpanel">
                                                        <div className="to-do-list-block-panel">
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="to-do-list-block">
                                                                <div className="d-flex justify-content-between gap-2 mb-3">
                                                                    <div className="d-flex gap-2">
                                                                        <span className="badge badge-pill badge-soft-secondary font-size-11">Waiting</span>
                                                                        <span className="badge badge-pill badge-soft-primary font-size-11">Approved</span>
                                                                        <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
                                                                    </div>
                                                                    <div className="btn-group position-relative">
                                                                        <a type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" href="#">Edit</a>
                                                                            <a className="dropdown-item text-danger" href="#">Delete</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4>Create Monthly Revenue Recap for all product linear</h4>
                                                                <div className="py-2 d-flex justify-content-between gap-2">
                                                                    <p className="d-flex gap-1 align-items-center mb-0"><i className="bx bx-calendar"></i> Due Date 11th Jan 2025</p>
                                                                    <p className="mb-0">4/12</p>
                                                                </div>
                                                                <div className="d-flex py-1 justify-content-between gap-2 align-items-center">
                                                                    <div className="avatar-xs">
                                                                        <span className="avatar-title rounded-circle badge-soft-secondary text-white">
                                                                            3 +
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-link-alt"></i>8
                                                                        </p>
                                                                        <p className="d-flex gap-1 align-items-center mb-0">
                                                                            <i className="bx bx-message-alt-dots"></i>15
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane" id="profile12" role="tabpanel">
                                                <div style={{minHeight: '528px'}}>
                                                    <div className="section-heading mb-1">
                                                        <h2>To do overview</h2>
                                                    </div>
                                                    <div className="row text-center">
                                                        <div className="col-4">
                                                            <h5 className="mb-0">9595</h5>
                                                            <p className="text-muted text-truncate">Total Loan</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <h5 className="mb-0">36524</h5>
                                                            <p className="text-muted text-truncate">Inprogress</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <h5 className="mb-0">62541</h5>
                                                            <p className="text-muted text-truncate">Completed</p>
                                                        </div>
                                                    </div>
                    
                                                    <div  className="apex-charts"  dir="ltr">
                                                        <img src="/assets/images/image_chart_1.png"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                


















                            </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <div className="section-heading">
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <h2>Loan Tracker</h2>
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <form className="app-search py-0">
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                      />
                      <span className="bx bx-search-alt"></span>
                    </div>
                  </form>
                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-light-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" href="#">
                        Search
                      </a>
                      <a className="dropdown-item" href="#">
                        Export
                      </a>
                      <a className="dropdown-item" href="#">
                        Settings
                      </a>
                      <a className="dropdown-item" href="#">
                        Advance Search
                      </a>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table
                    id="datatable"
                    className="table table-bordered table-striped dt-responsive nowrap"
                    style={{
                      borderCollapse: "collapse",
                      borderSpacing: "0",
                      width: "100%",
                    }}
                  >
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Loan Info</th>
                        <th>Status</th>
                        <th>Est Closing Date</th>
                        <th>Referred</th>
                        <th>Loan Officer</th>
                        <th>Financier</th>
                        <th>Mortgage Administrator</th>
                        <th>Observer</th>
                        <th>Last Update</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>203895</td>
                        <td>$1512</td>
                        <td>
                          <span className="badge badge-pill badge-soft-success font-size-12">
                            Open
                          </span>
                        </td>
                        <td>10-12-2024</td>
                        <td>Ashley Rooker</td>
                        <td>Stephanie Selleroli</td>
                        <td>KIND LENDING, LLC</td>
                        <td>Lori Nielsen</td>
                        <td>Alaxi Sampson</td>
                        <td>10-12-2024</td>
                        <td>
                          <div className="d-flex gap-2">
                            <a href="#">
                              <i className="assign-btn"></i>
                            </a>
                            <a href="#">
                              <i className="msg-btn"></i>
                            </a>
                            <a href="#">
                              <i className="edit-btn"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FundingOverview;
